/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class RisksRoute extends Route {
  // This uses the risks template but with the permissions controller
  // which handles all entity types
  @service
  store;

  controllerName = 'admin/events/permissions';

  model() {
    return hash({
      risks: this.store.findAll('events/risk'),
      mitigations: this.store.findAll('events/mitigation'),
    });
  }
}
